export const defineObjectProperty = (obj: any, key: string, value: any) => {
  var config = {
    value: value,
    writable: true,
    enumerable: true,
    configurable: true,
  };
  Object.defineProperty(obj, key, config);
};
